import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface VehicleTypeInputProps {
  value: string;
  onChange: (value: string) => void;
}

const VehicleTypeInput = ({ value, onChange }: VehicleTypeInputProps) => {
  return (
    <div>
      <Label>Vehicle Type</Label>
      <RadioGroup
        value={value}
        onValueChange={onChange}
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="2-wheeler" id="two-wheeler" />
          <Label htmlFor="two-wheeler">2 Wheeler</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="4-wheeler" id="four-wheeler" />
          <Label htmlFor="four-wheeler">4 Wheeler</Label>
        </div>
      </RadioGroup>
    </div>
  );
};

export default VehicleTypeInput;